import textPageLoginTH from './pages/login/TH.json'
import textButtonTH from './pages/button/TH.json'
import textHeaderTH from './pages/header/TH.json'
import textRoomTH from './pages/room/TH.json'
import textAdvanceSearchTH from './pages/advanceSearch/TH.json'
import textLocationTH from './pages/location/TH.json'
import textUserTH from './pages/user/TH.json'
import textRoleTH from './pages/role/TH.json'
import textProfileTH from './pages/profile/TH.json'
import textBGTH from './pages/bg/TH.json'
import textFacNFoodTH from './pages/facNfood/TH.json'
import textIOTTH from './pages/iot/TH.json'
import textEventTH from './pages/event/TH.json'
import textOrderTH from './pages/order/TH.json'
import textSettingTH from './pages/setting/TH.json'
import textReportTH from './pages/report/TH.json'
import textMonitorTH from './pages/Monitor/TH.json'
import textValidate from './pages/validate/TH.json'
import textModal from './pages/modal/TH.json'
import textError from './pages/error/TH.json'
import textIntegration from './pages/integration/TH.json'

export default {
    login: {
        ...textPageLoginTH
    },
    button: {
        ...textButtonTH
    },
    header: {
        ...textHeaderTH
    },
    room: {
        ...textRoomTH
    },
    advanceSearch: {
        ...textAdvanceSearchTH
    },
    location: {
        ...textLocationTH
    },
    user: {
        ...textUserTH
    },
    role: {
        ...textRoleTH
    },
    profile: {
        ...textProfileTH
    },
    bg: {
        ...textBGTH
    },
    facNfood: {
        ...textFacNFoodTH
    },
    iot: {
        ...textIOTTH
    },
    event: {
        ...textEventTH
    },
    order: {
        ...textOrderTH
    },
    setting: {
        ...textSettingTH
    },
    report: {
        ...textReportTH
    },
    monitor: {
        ...textMonitorTH
    },
    validate: {
        ...textValidate
    },
    modal: {
        ...textModal
    },
    error: {
        ...textError
    },
    integration: {
        ...textIntegration
    },
    noResult: "ไม่พบข้อมูล",
    logo: "สัญลักษณ์ในทุกอุปกรณ์",
    home: "หน้าหลัก",
    name: "ชื่อ",
    fileSize: "ขนาดไฟล์ต้องไม่เกิน 10 MB",
    selectAll: "เลือกทั้งหมด",
    takePhoto: "ถ่ายภาพ",
    uploadPhoto: "อัพโหลดรูปภาพ",
    deletePhoto: "ลบรูปภาพ"
}


// WEBPACK FOOTER //
// ./src/wording/th.js